export const email = val => !!val && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val) && 'Invalid email address';
export const postcode = val =>
	!!val && !/^(GIR 0AA)|((([A-Z][0-9][0-9]?)|(([A-Z][A-HJ-Y][0-9][0-9]?)|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2})$/i.test(val) && 'Invalid postcode';
export const nino = val => !!val && !/(^[A-Z]{2}[0-9]{6}[A-Z]?$)|(^[0-9]{2}[A-Z][0-9]{5}$)/i.test(val) && 'Invalid National Insurance number - type without spaces';

export const telno = val => !!val && !/^[\+0][0-9 ]{9,20}$/i.test(val) && 'Invalid phone number';
export const pass = val => !!val && !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{7,}$/i.test(val) && 'Invalid password';
export const pin = val => !!val && !/^[0-9]{4,6}$/.test(val) && 'Invalid pin';
export const moneyNoPence = val => !!val && !/^-?[0-9]*$/.test(val) && "Don't include pence";
export const money = val => !!val && !/^-?[0-9]*(\.[0-9]{2})?$/.test(val) && 'Not money';
export const dateVal = val => {
	if (!val) return false;
	const da = new Date(val);
	return !(da && Object.prototype.toString.call(da) === '[object Date]' && !isNaN(da)) && 'Invalid Date';
};
//MTR Specdocs
export const EmailAddress = val => !!val && !/[A-Za-z0-9\.\-_]{1,64}@[A-Za-z0-9\.\-_]{1,64}/.test(val) && 'Invalid Email Address';
export const UTRType = val => !!val && !/^[0-9]{10}$/.test(val) && 'UTR is 10 digits';
export const SAtelephoneNumberType = val => !!val && !/[0-9 ]{1,20}/.test(val) && 'Invalid phone number';
export const SAstringType = val => !!val && !/[A-Za-z0-9 &'\(\)\*,\-\./@£]*/.test(val) && 'Invalid characters';
export const SAnonZeroMonetaryType = val => !!val && !/-?[0-9.]*[1-9]+[0-9.]*/.test(val) && 'Invalid characters';
export const SAbuildingSocietyReferenceType = val => !!val && !/[A-Z0-9\-/]{1,18}/.test(val) && 'Invalid characters';
export const SAnonEmptyStringType = val => !!val && !/.*[^\s]+.*/.test(val) && 'Invalid characters';
